import { useCampersList } from '../hooks/useCamper';
import { Link } from 'react-router-dom';

export function Campers() {
  const { campers, isLoading } = useCampersList();

  if (isLoading) return <div>Loading...</div>;

  // Optional: icon mapping for known shorthand icons
  const iconMapping = {
    seat: 'airline_seat_recline_normal'
    // add further mappings if needed
  };

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <div className="relative bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-center mb-4">
            Nuestras Campers
          </h1>
          <p className="text-xl text-center text-gray-600 max-w-3xl mx-auto">
            Descubre nuestra flota de furgonetas camper, cada una diseñada para ofrecer una experiencia única de viaje.
          </p>
        </div>
      </div>

      {/* Campers Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid gap-16">
          {campers.map((camper) => {
            const imageUrl = camper.mainImage && camper.mainImage.fields
              ? camper.mainImage.fields.file.url
              : camper.mainImage;
            return (
              <div key={camper.slug} className="grid md:grid-cols-2 gap-8 items-center">
                <div className="relative aspect-[4/3] overflow-hidden rounded-lg">
                  <img
                    src={imageUrl}
                    alt={camper.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h2 className="text-3xl font-bold mb-4">{camper.name}</h2>
                  <p className="text-xl text-gray-600 mb-6">
                    {camper.shortDescription}
                  </p>
                  <div className="space-y-4 mb-8">
                    {camper.highlights.slice(0, 2).map((highlight, index) => (
                      <div key={index} className="flex items-center gap-4">
                        <span className="material-symbols-outlined text-brand text-2xl">
                          {iconMapping[highlight.icon] || highlight.icon}
                        </span>
                        <span>{highlight.text}</span>
                      </div>
                    ))}
                  </div>
                  <Link
                    to={`/campers/${camper.slug}`}
                    className="inline-block bg-brand text-white px-8 py-3 rounded-lg font-semibold hover:bg-brand-dark transition-colors"
                  >
                    Ver detalles
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
} 